import type { ReactNode } from 'react'

interface PageHeaderProps {
  title: ReactNode
  description?: ReactNode
  /** Right-aligned actions; at most one primary button. */
  actions?: ReactNode
  /** Small line above the title (e.g. a back link). */
  eyebrow?: ReactNode
}

/** The title block every dashboard and ops page starts with. */
export function PageHeader({ title, description, actions, eyebrow }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div className="min-w-0 space-y-1">
        {eyebrow ? <div className="text-caption text-muted-foreground">{eyebrow}</div> : null}
        <h1 className="text-heading font-semibold tracking-tight">{title}</h1>
        {description ? <p className="text-body text-muted-foreground">{description}</p> : null}
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-2">{actions}</div> : null}
    </div>
  )
}
